import { Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { WEBSITE_URL } from "@lib/firebase";
import LoadingScreen from "@/components/LoadingScreen";

function FullScreenMessage({ title, body, action }) {
  return (
    <div className="flex h-screen w-full flex-col items-center justify-center gap-3 px-6 text-center">
      <p className="text-lg font-bold text-navy-700 dark:text-white">{title}</p>
      {body && <p className="max-w-md text-sm text-gray-600">{body}</p>}
      {action}
    </div>
  );
}

/**
 * Gate for everything under /admin.
 *
 * Sign-in is owned by the marketing site, so an unauthenticated visitor is sent
 * there rather than to a local login form.
 */
export default function RequireAuth({ children }) {
  const { user, businessId, loading, error } = useAuth();

  if (loading) {
    return <LoadingScreen />;
  }

  if (!user) {
    window.location.replace(`${WEBSITE_URL}/login`);
    return <LoadingScreen message="Redirecting to sign in..." />;
  }

  if (!businessId) {
    return (
      <FullScreenMessage
        title="No business linked to this account"
        body={error || "Ask an administrator to add you to a business, then sign in again."}
        action={
          <a
            href={`${WEBSITE_URL}/contact`}
            className="linear mt-2 rounded-xl bg-brand-500 px-6 py-3 text-base font-medium text-white transition duration-200 hover:bg-brand-600"
          >
            Contact support
          </a>
        }
      />
    );
  }

  return children ?? <Outlet />;
}
